import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';

export default function CookieNotice() {
  return (
    <div className="min-h-screen bg-surface">
      <nav className="border-b border-outline-variant/20 bg-surface/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo className="h-9 text-primary" />
          </Link>
          <Link to="/auth" className="text-xs font-bold uppercase tracking-widest text-primary hover:opacity-80 transition-opacity">Open Calculator</Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs font-bold uppercase tracking-widest text-on-surface-variant mb-4">Legal</p>
        <h1 className="text-4xl font-headline font-bold text-primary mb-4">Cookie Notice</h1>
        <p className="text-sm text-on-surface-variant mb-12">Effective 13 April 2026</p>

        <div className="prose prose-sm max-w-none space-y-8 font-body text-on-surface">

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">What are cookies?</h2>
            <p className="leading-relaxed text-on-surface-variant">
              Cookies are small text files stored on your device when you visit a website. We use session cookies and similar technologies to operate the platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">How we use cookies</h2>
            <ul className="list-disc pl-6 space-y-2 text-on-surface-variant">
              <li><strong>Session authentication:</strong> We use a session cookie to keep you signed in while using the platform. This cookie is deleted when you sign out or close your browser session.</li>
              <li><strong>CSRF protection:</strong> We use cookies to protect against cross-site request forgery attacks.</li>
              <li><strong>Preferences:</strong> We may use cookies to remember interface preferences.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">What we do not do</h2>
            <ul className="list-disc pl-6 space-y-2 text-on-surface-variant">
              <li>We do not use advertising cookies or tracking pixels.</li>
              <li>We do not share cookie data with advertising networks.</li>
              <li>We do not use cookies to build profiles for marketing purposes.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Managing cookies</h2>
            <p className="leading-relaxed text-on-surface-variant">
              You can control and delete cookies through your browser settings. Disabling session cookies will prevent you from signing in to the platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-headline font-bold text-primary mb-3">Contact</h2>
            <p className="leading-relaxed text-on-surface-variant">
              For questions about cookies or privacy: <a href="mailto:carter.b.xu@gmail.com" className="text-primary underline">carter.b.xu@gmail.com</a>
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t border-outline-variant/20 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-wrap gap-4 text-xs text-on-surface-variant">
          <Link to="/legal/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
          <Link to="/legal/terms-of-use" className="hover:text-primary transition-colors">Terms of Use</Link>
          <Link to="/legal/cookie-notice" className="hover:text-primary transition-colors font-bold text-primary">Cookie Notice</Link>
          <Link to="/legal/output-disclaimer" className="hover:text-primary transition-colors">Output Disclaimer</Link>
        </div>
      </footer>
    </div>
  );
}
